import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base';
import Utils from '../js/utils';
import Employee from '../js/employee';
export default (function ($prop, ctx) {
  ctx.$on('popup:open', function () {
    if (Employee.incomeRow == null) return false;
    var pn = 'div[data-name="income-bonus-popup"]';

    var reload = function reload() {
      $(pn + ' table tbody').html('');
      var $td = $(pn + ' table tfoot tr td:nth-child(2)');
      $td.text('');
      var rows = Employee.incomeRow.thuongphat_rows;
      var total = 0;
      if (rows.length == 0) return false;
      Employee.incomeRow.thuong_phat = 0;
      rows.forEach(function (item, i) {
        var $tr = appendTr(item);
        Employee.incomeRow.thuong_phat += item.so_tien * item.loai;
        $(pn + ' table tbody').append($tr);
      });
      var color = 'text-color-green';
      var s = '+';

      if (Employee.incomeRow.thuong_phat < 0) {
        color = 'text-color-red';
        s = '';
      }

      $td.removeClass('text-color-green');
      $td.removeClass('text-color-red');
      $td.addClass(color).text(s + Utils.num2Str(Employee.incomeRow.thuong_phat));
    };

    var appendTr = function appendTr(item) {
      var sotien = item.so_tien * item.loai;
      var sotien_string = '';
      var color = 'text-color-green';

      if (item.loai > 0) {
        sotien_string = "+".concat(Utils.num2Str(sotien));
      } else {
        color = 'text-color-red';
        sotien_string = Utils.num2Str(sotien);
      }

      var $tr = $("<tr><td>".concat(item.ly_do, "</td><td class=\"numeric-cell ").concat(color, "\">").concat(sotien_string, "</td></tr>"));
      $tr.click(function () {
        Base.app.dialog.confirm('Xoá?', 'Xác nhận', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var index, loader, rs;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  index = Employee.incomeRow.thuongphat_rows.indexOf(item);
                  if (index > -1) Employee.incomeRow.thuongphat_rows.splice(index, 1);
                  loader = Base.app.dialog.preloader();
                  _context.next = 5;
                  return Base.api('Income', 'deleteThuongPhat', item);

                case 5:
                  rs = _context.sent;
                  loader.close();
                  $tr.remove();
                  reload(); //Tính lại tổng thưởng/phạt

                  Employee.incomeRow.thuong_phat = Employee.incomeRow.thuongphat_rows.reduce(function (total, row) {
                    return total + row.so_tien * row.loai;
                  }, 0);
                  Base.app.emit('onThuongPhatChanged');

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })));
      });
      return $tr;
    };

    $(pn + ' .addnew-button').click(function () {
      var item = {};
      item.name = Employee.currentRow.name;
      item.id_emp = Employee.currentRow.id;
      item.thang = Employee.incomeRow.thang;
      item.nam = Employee.incomeRow.nam;
      Employee.ThuongPhat.openForm(item, function (rs) {
        Employee.incomeRow.thuongphat_rows.push(rs.inserted_row);
        reload(); //Tính lại tổng thưởng/phạt

        Employee.incomeRow.thuong_phat = Employee.incomeRow.thuongphat_rows.reduce(function (total, row) {
          return total + row.so_tien * row.loai;
        }, 0);
        Base.app.emit('onThuongPhatChanged');
      });
    });
    reload();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup" data-name="income-bonus-popup">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="title">Chi tiết Thưởng/Phạt</div>
        <div class="right">
          <a href="#" class="link popup-close"><i class="icon f7-icons">multiply</i></a>
        </div>
      </div>
    </div>
    <div class="page-content no-padding">
      <div class="data-table">
        <table>
          <thead>
            <tr>
              <th class="label-cell">Mô tả</th>
              <th class="numeric-cell">Số tiền</th>
            </tr>
          </thead>
          <tbody>
          </tbody>
          <tfoot>
            <tr style="border-top:#333333 1px dotted;">
              <td class="numeric-cell text-bold">TỔNG</td>
              <td class="numeric-cell text-bold">0</td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="block block-strong text-align-center">
        <a href="#" class="button addnew-button">Thêm mới</a>
      </div>
    </div>
  </div>
`
    }
    ;
});